import React, { useEffect, useState } from 'react'
import { Button, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import axios from 'axios';

import './../styles/car-model-selector.css'

import { FLOOR_MAT_API_URLS } from '../constants/urls';
import { useFloorMatStore } from '../stores/floor-mat-store';
import {
  FLOOR_MAT_API_KEY,
  FLOOR_MAT_BRAND_CODE,
  FLOOR_MAT_DOMAIN_NAME,
  FLOOR_MAT_PRODUCT_LINE_CODE
} from '../constants/api';

axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';

const apiConfig = {
  "brand_code" : FLOOR_MAT_BRAND_CODE,
  "apikey" : FLOOR_MAT_API_KEY,
  "domainName" : FLOOR_MAT_DOMAIN_NAME,
  "product_line_code": FLOOR_MAT_PRODUCT_LINE_CODE
};

function FloorMatCarSelector({ selectedCar, setSelectedCar }) {
  const setMatOptions = useFloorMatStore(state => state.setMatOptions);
  const setSelectedMatAreas = useFloorMatStore(state => state.setMatOptions);
  const setTotal = useFloorMatStore(state => state.setMatOptions);
  let initialApiParams = {
    ...apiConfig
  };
  let hasPreviousCarSelection = false;

  if (selectedCar.year && selectedCar.make && selectedCar.model) {
    initialApiParams = {
      ...initialApiParams,
      year: selectedCar.year,
      make: selectedCar.make?.id,
      makeName: selectedCar.make?.makeName,
      base_vehicle_id: selectedCar.model?.baseVehicleId,
      modelName: selectedCar.model?.modelName,
    }

    if (selectedCar.submodel) {
      initialApiParams.vehicle_unique = selectedCar.submodel;
    }

    hasPreviousCarSelection = true;
  }

  const [carYears, setCarYears] = useState([]);
  const [carMakes, setCarMakes] = useState([]);
  const [carModels, setCarModels] = useState([]);
  const [carSubmodels, setCarSubmodels] = useState([]);
  const [carYear, setCarYear] = useState("");
  const [carMake, setCarMake] = useState("");
  const [carModel, setCarModel] = useState("");
  const [carSubmodel, setCarSubmodel] = useState("");
  const [isCarSelected, setIsCarSelected] = useState(hasPreviousCarSelection);
  const [apiParams, setApiParams] = useState(initialApiParams);

  const resetSelections = () => {
    setCarYear("");
    setCarMake("");
    setCarMakes([]);
    setCarModel("");
    setCarModels([]);
    setCarSubmodel("");
    setCarSubmodels([]);
    setSelectedCar({});
    setApiParams(apiConfig);
    setMatOptions([]);
    setIsCarSelected(false);
    setSelectedMatAreas();
    setTotal();

    localStorage.removeItem('fm-car-year');
    localStorage.removeItem('fm-car-make');
    localStorage.removeItem('fm-car-model');
    localStorage.removeItem('fm-car-submodel');
  }

  const initConfig = async () => {
    const { data: { data } } =
      await axios.post(`${FLOOR_MAT_API_URLS.BASE}${FLOOR_MAT_API_URLS.INIT}`, apiParams);

    console.log('data', data);

    if (data?.shopperId) {
      setApiParams({
        ...apiParams,
        shopperId: data.shopperId
      });
      getCarYears();
    }

    if (isCarSelected) {
      getCarOptions(isCarSelected);
    }
  }

  const getCarYears = async () => {
    const { data: {data} } =
      await axios.post(`${FLOOR_MAT_API_URLS.BASE}${FLOOR_MAT_API_URLS.YEAR}`, apiParams);

    console.log('getCarYears data', data);

    setCarYears(data);
  }

  const getCarMakes = async () => {
    setCarMake("");
    setCarMakes([]);
    setCarModel("");
    setCarModels([]);
    setCarSubmodel("");
    setCarSubmodels([]);

    if (carYear) {
      const { data: {data} } =
        await axios.post(`${FLOOR_MAT_API_URLS.BASE}${FLOOR_MAT_API_URLS.MAKE}`, apiParams);

      console.log('getCarMakes data', data);
      setCarMakes(data);
    }
  }

  const getCarModels = async () => {
    setCarModel("");
    setCarModels([]);
    setCarSubmodel("");
    setCarSubmodels([]);

    if (carYear && carMake) {
      const { data: {data} } =
        await axios.post(`${FLOOR_MAT_API_URLS.BASE}${FLOOR_MAT_API_URLS.MODEL}`, apiParams);

      console.log('getCarModels data', data);
      setCarModels(data);
    }

  }

  const getCarSubmodels = async () => {
    setCarSubmodel("");
    setCarSubmodels([]);

    if (carYear && carMake && carModel) {
      const { data } =
        await axios.post(`${FLOOR_MAT_API_URLS.BASE}${FLOOR_MAT_API_URLS.VEHICLE}`, apiParams);

      console.log('getCarSubmodels data', data);

      const mergeSubmodels = function(objects) {
        let out = {};
        for (let i = 0; i < objects.length; i++) {
          for (let p in objects[i]) {
            out[p] = objects[i][p];
          }
        }
        return out;
      }

      const flattenSubmodels = function(obj, name, stem) {
        let out = {};
        let newStem = (typeof stem !== 'undefined' && stem !== '') ? stem + '|' + name : name;
        if (typeof obj !== 'object' || Object.keys(obj).length === 0) {
          out[newStem] = obj;
          return out;
        }
        for (let p in obj) {
          let prop = flattenSubmodels(obj[p], p, newStem);
          out = mergeSubmodels([out, prop]);
        }
        return out;
      };

      const submodelData = Object.keys(data).length > 0 ? flattenSubmodels(data) : data;
      const submodels = Object.keys(submodelData);

      console.log('submodels', submodels);

      setCarSubmodels(submodels);

      if (!submodels.length) {
        setIsCarSelected(true);
        getCarOptions(true);
      }
    }
  }

  const getCarOptions = async (isCarSelected) => {
    if (selectedCar?.year && selectedCar?.make && selectedCar?.model && (selectedCar.submodel || isCarSelected)) {
      const { data: {data} } =
        await axios.post(`${FLOOR_MAT_API_URLS.BASE}${FLOOR_MAT_API_URLS.PRODUCT_LIST}`, apiParams);

      setMatOptions(data?.product_list);
    }
  }

  useEffect(() => {
    initConfig(apiConfig);
  }, []);

  useEffect(() => {
    getCarMakes();
  }, [carYear]);

  useEffect(() => {
    getCarModels();
  }, [carMake]);

  useEffect(() => {
    getCarSubmodels();
  }, [carModel]);

  useEffect(() => {
    getCarOptions();
  }, [carSubmodel]);

  const handleCarYearChange = (e) => {
    const selectedYear = e.target.value;
    setCarYear(selectedYear);
    setApiParams({
      ...apiParams,
      year: selectedYear
    });
    setSelectedCar({
      ...selectedCar,
      year: selectedYear
    });
    localStorage.setItem('fm-car-year', selectedYear);
  }
  const handleCarMakeChange = (e) => {
    const selectedMake = e.target.value;

    console.log('selectedMake', selectedMake);

    setCarMake(selectedMake);
    setApiParams({
      ...apiParams,
      make: selectedMake.id,
      makeName: selectedMake.makeName,
    });
    setSelectedCar({
      ...selectedCar,
      make: selectedMake
    })
    localStorage.setItem('fm-car-make', JSON.stringify(selectedMake));
  }
  const handleCarModelChange = (e) => {
    const selectedModel = e.target.value;
    setCarModel(selectedModel);
    setApiParams({
      ...apiParams,
      base_vehicle_id: selectedModel.baseVehicleId,
      modelName: selectedModel.modelName,
    });
    setSelectedCar({
      ...selectedCar,
      model: selectedModel
    })
    localStorage.setItem('fm-car-model', JSON.stringify(selectedModel));
  }
  const handleCarSubmodelChange = (e) => {
    const selectedSubmodel = e.target.value;
    setCarSubmodel(selectedSubmodel);
    setApiParams({
      ...apiParams,
      vehicle_unique: selectedSubmodel
    });
    setSelectedCar({
      ...selectedCar,
      submodel: selectedSubmodel
    })
    setIsCarSelected(true);
    localStorage.setItem('fm-car-submodel', selectedSubmodel);
  }

  return (
    <section className="car-model-selector-container">
      {selectedCar?.year && selectedCar?.make && selectedCar?.model && (selectedCar?.submodel || isCarSelected) ? (
        <div className="selected-car-wrapper">
          <div className="selected-car-container">
            <p className="selected-car">
              {selectedCar?.year} {selectedCar?.make?.makeName} {selectedCar?.model?.modelName} {selectedCar?.submodel}
            </p>
            <Button
              onClick={resetSelections}
              variant="contained"
              size="large"
              className="clear-selection-button"
            >
              Change
            </Button>
          </div>
          <div className="car-options-selected-container">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M12 20C7.59 20 4 16.41 4 12S7.59 4 12 4 20 7.59 20 12 16.41 20 12 20M16.59 7.58L10 14.17L7.41 11.59L6 13L10 17L18 9L16.59 7.58Z" />
            </svg>
            <p className="car-options-selected-notice">Custom Fit for Your Vehicle</p>
          </div>
        </div>
      ) : (
        <>
          <FormControl fullWidth className="car-model-form-control">
            <InputLabel id="car-year-label">Select Year</InputLabel>
            <Select
              labelId="car-year-label"
              id="car-year"
              value={carYear}
              label="Select Year"
              onChange={handleCarYearChange}
              className="car-model-select car-year-select"
            >
              {carYears.map(year => (
                <MenuItem key={year} value={year}>{year}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth className="car-model-form-control">
            <InputLabel id="car-make-label">Select Make</InputLabel>
            <Select
              labelId="car-make-label"
              id="car-make"
              value={carMake}
              label="Select Make"
              onChange={handleCarMakeChange}
              className="car-model-select car-make-select"
              disabled={!carYear}
            >
              {carMakes.map(make => (
                <MenuItem key={make.id} value={make}>{make.makeName}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth className="car-model-form-control">
            <InputLabel id="car-model-label">Select Model</InputLabel>
            <Select
              labelId="car-model-label"
              id="car-model"
              value={carModel}
              label="Select Model"
              onChange={handleCarModelChange}
              className="car-model-select"
              disabled={!carMake}
            >
              {carModels.map(model => (
                <MenuItem key={model.id} value={model}>{model.modelName}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth className="car-model-form-control">
            <InputLabel id="car-submodel-label">Select Trim (If Necessary)</InputLabel>
            <Select
              labelId="car-submodel-label"
              id="car-submodel"
              value={carSubmodel}
              label="Select Trim (If Necessary)"
              onChange={handleCarSubmodelChange}
              className="car-model-select car-submodel-select"
              disabled={!carModel}
            >
              {carSubmodels?.map(submodel => (
                <MenuItem key={submodel} value={submodel}>{submodel}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </>
      )}
    </section>
  )
}

export default FloorMatCarSelector
